module.exports = __webpack_public_path__ + "static/mpm-store-emkt-5980b0652381d6ae0403ba9b2984cec3.jpg";